var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"app"}},[_c('Navbar'),_c('Slider'),_c('v-content',{staticClass:"ma-0 pa-0 content"},[_c('transition',[_c('router-view')],1)],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }